import {Component, OnInit} from '@angular/core';
import {Localiser} from '../../../services/localiser';
import {MatDialogRef} from '@angular/material/dialog';
import {ProyectoService} from '../../../services/proyecto.service';
import {EmpresaService} from '../../../services/empresa.service';

@Component({
  selector: 'app-delete-company',
  templateUrl: './delete-company.component.html',
  styleUrls: ['./delete-company.component.css']
})
export class DeleteCompanyComponent implements OnInit {

  constructor(public localiser: Localiser, public dialogRef: MatDialogRef<DeleteCompanyComponent>,
              private empresaService: EmpresaService) { }

  deleteItem: boolean = false;

  deleting = false;


  dataList: any;
  selectedItem: any;

  ngOnInit(): void {
    this.empresaService.getAll().subscribe(result => {
      this.dataList = result;
    });
  }

  goBack() {
    this.deleteItem = false;
  }

  delete() {
    if(this.deleteItem === false) {
      this.deleteItem = true;
      return;
    }

    this.deleting = true;
    this.empresaService.delete(this.selectedItem.idEmpresa).subscribe(result => {
      this.dialogRef.close(true);

    });
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
